import React from 'react'
import { Main } from '../Components/PaymentCoponent/Main'

export const CartPayment = () => {
  return (
    <>
    <Main/>
    </>
  )
}
